import { render, staticRenderFns } from "./AboutTeamIntro.vue?vue&type=template&id=1b678748&"
import script from "./AboutTeamIntro.vue?vue&type=script&lang=js&"
export * from "./AboutTeamIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports